<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <article class="form-heading title-section form-section flex">
            <h1 class="form-title" style="width: 345px;">Your Premium Proposal</h1>
            <img
              src="../../../public/assets/images/financial.png"
              class="title-section-img form-title-img financial-section-img"
              alt="background image"
            >
          </article>
          <article class="input-section form-section">
            <div class="form-inline mb-3">
              <label class="mr-2 label-price">
                <h5 class="strong w-100">Limits of Coverage:</h5>
              </label>
              <h5 class="strong">{{coverage}}</h5>
            </div>
            <div class="form-inline">
              <label class="mr-2 label-price">
                <h5 class="w-100 font-weight-bold">Premium Due:</h5>
              </label>
              <h5 class="font-weight-bold">${{(state.premium).toFixed(2)}}</h5>
            </div>
            <h5 class="font-weight-bold mt-3">Add On Coverages:</h5>
            <div class="radio orep-radio-wrapper solo-checkbox">
              <label>
                <input
                  type="checkbox"
                  name="amcExtensionCoverage"
                  class="orep-radio"
                  v-model="individualAppraiser.amcExtensionCoverage"
                >
                <span class="radio-span solo-checkbox-span">
                  Add AMC Extension Coverage (10% of Premium) <strong>{{individualAppraiser.amcExtensionCoverage ? '$'+(state.premium * 0.1).toFixed(2) : ''}}</strong>
                </span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper solo-checkbox">
              <label>
                <input
                  type="checkbox"
                  name="traineeCoverage"
                  class="orep-radio"
                  v-model="individualAppraiser.traineeCoverage"
                >
                <span class="radio-span solo-checkbox-span">
                  Add Trainee Coverage (50% of Premium) <strong>{{individualAppraiser.traineeCoverage ? '$'+(state.premium * 0.5).toFixed(2) : ''}}</strong>
                </span>
              </label>
            </div>
            <div class="form-inline mt-4">
              <label class="mr-2 label-price">
                <h5 class="w-100 strong">Total Premium:</h5>
              </label>
              <h5 class="strong">${{total.toFixed(2)}}</h5>
            </div>
          </article>
          <article class="d-flex form-heading title-section form-section" style="height: 100px;">
            <p class="form-title text-center m-0 w-100" style="font-size: 35px;">
              PLEASE READ
            </p>
          </article>
          <article class="input-section form-section">
            <ol style="margin-right: 56px;">
              <li class="mb-3">
                Standard Deductible of $500 per claim/$1,000 annual aggregate is included in each policy.
                Note: <span class="font-weight-bold" style="text-decoration: underline;">OREP Members enjoy a $0 deductible for participating in OREP’s Risk Management Program.</span>
              </li>
              <li>
                OREP charges a Professional Services Fee for membership in OREP’s Risk Management Program, which includes a zero deductible, free approved Continuing Education, free webinars, Working RE and more. Premiums listed above are subject to change based on carrier filings and should not be considered final until written confirmation is obtained from the carrier.
              </li>
            </ol>
          </article>

          <article class="input-section form-section">
            <div style="margin-right: 56px;">
              <h5 class="strong">Additional Coverages Available:</h5>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <p class="font-weight-bold mb-0">General Liability</p>
                      <span>
                        <i>
                          <strong>Important Coverage Note:</strong>
                           If you’d like a quote on a low-cost General Liability (GL) policy that includes Loss of Income coverage, Personal Property coverage (computers, client records, buildings) and Employee Dishonesty, please check this box. Premiums range from $175 - $500. The separate GL quote will follow and will not delay the processing of this E&O coverage.
                        </i>
                      </span>
                    </td>
                    <td>
                      <div class="radio orep-radio-wrapper solo-checkbox">
                        <label class="m-0 justify-content-center">
                          <input
                            type="checkbox"
                            name="sendInfoForBipdCoverage"
                            class="orep-radio"
                            v-model="individualAppraiser.sendInfoForBipdCoverage"
                          >
                        </label>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="font-weight-bold mb-0">Cyber Coverage</p>
                      <span>
                        <i>
                          Please send me information on Cyber Liability Coverage. This coverage provides coverage due to unauthorized breach of your electronic records.
                        </i>
                      </span>
                    </td>
                    <td>
                      <div class="radio orep-radio-wrapper solo-checkbox">
                        <label class="m-0 justify-content-center">
                          <input
                            type="checkbox"
                            name="sendInfoForCyberLiabilityCoverage"
                            class="orep-radio"
                            v-model="individualAppraiser.sendInfoForCyberLiabilityCoverage"
                          >
                        </label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </article>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'individual-appraiser-2'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToOne()"></button>
              <button class="pagination-dots" @click="prev()"></button>
              <span class="pagination-dots pagination-current"></span>
              <button class="pagination-dots" @click="navigateToNext('individual-appraiser-4')" :disabled="!state.pageThreeIsValid"></button>
              <button
                class="pagination-dots"
                @click="navigateToNext('individual-appraiser-5')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('individual-appraiser-6')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid">
              </button>
            </article>
            <button
              type="submit"
              :disabled="!state.pageThreeIsValid"
              :class="{submitDisabled: !state.pageThreeIsValid}"
              class="next-btn mont spaced pull-right"
              @click="navigateToNext('individual-appraiser-4')"
            >Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "individual-appraiser-3",
  computed: {
    individualAppraiser() {
      return this.$store.state.individualAppraiser.individualAppraiser;
    },
    state() {
      return this.$store.state.individualAppraiser;
    },
    errorMsg() {
      return this.$store.state.individualAppraiser.errorMsg;
    },
    total() {
        let total = this.state.premium;
        if (this.individualAppraiser.amcExtensionCoverage) {
          total += this.state.premium * 0.1;
        }
        if (this.individualAppraiser.traineeCoverage) {
          total += this.state.premium * 0.5;
        }

        return total;
      },
    coverage() {
      switch (this.individualAppraiser.limitOfCoverage) {
        case '0.3M/0.6M':
          return '$300,000 / $600,000';
        case '0.5M/1M':
          return '$500,000 / $1,000,000';
        case '1M/1M':
          return '$1,000,000 / $1,000,000';
        default:
          return '$1,000,000 / $2,000,000';
      }
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    prev() {
      this.$router.push({
        name: "individual-appraiser-2"
      });
    },

    navigateToOne() {
      this.$router.push({
        name: "individual-appraiser-1"
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageThreeIsValid = true;
          return;
        }
        this.state.pageThreeIsValid = false;
      });
    },
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);

    if (!this.state.premium) {
      this.$router.push({
        name: "individual-appraiser-2"
      });
    }
  },
};
</script>

<style scoped>
  .strong {
    font-weight: bold;
  }
  table td {
    border: 1px solid black;
  }
  table tr > td:last-child {
    width: 100px;
  }
  table tr > td:first-child {
    padding: 10px;
  }
  .label-price {
    width: 220px;
  }
</style>

